import axiosClient from "@/utils/axios-client";
import { toCamelKeyObject, toSnakeKeyObject } from "@/utils/case";
import {
  ShippingInfoRequestBody,
  ShippingInfoResponse,
} from "@/shared/api/shipping-infos/types";
import { CompanyTypeRequestFormat } from "@/shared/types";
import { shippingInfosUrl } from "@/shared/api/shipping-infos/url";

export const shippingInfosMutationApi = {
  // 배송지 추가 — 호출부가 생성된 배송지를 곧바로 선택하므로
  // AxiosResponse가 아니라 camel로 변환한 응답 본문을 돌려준다.
  createShippingInfo: async (
    companyType: CompanyTypeRequestFormat,
    companyId: number,
    body: ShippingInfoRequestBody
  ): Promise<ShippingInfoResponse> => {
    const { data } = await axiosClient.post(
      shippingInfosUrl.byCompany(companyType, companyId),
      toSnakeKeyObject(body)
    );
    return toCamelKeyObject(data) as ShippingInfoResponse;
  },
};
